import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type HomeRailPanelProps = {
  title: string;
  link?: { label: string; to: string } | undefined;
  children: ReactNode;
};

/** Card shell shared by the Home side rails. */
export function HomeRailPanel({ title, link, children }: HomeRailPanelProps) {
  return (
    <section
      className="flex flex-col gap-3.5 rounded-2xl border p-[18px] shadow-[var(--gs-shadow,0_1px_2px_rgba(20,20,20,0.04),0_6px_20px_rgba(20,20,20,0.05))]"
      style={{ background: 'var(--gs-panel)', borderColor: 'var(--gs-line)' }}
    >
      <div className="flex items-center justify-between">
        <h2
          className="m-0 text-[17px] font-extrabold tracking-[-0.01em]"
          style={{ color: 'var(--gs-ink)' }}
        >
          {title}
        </h2>
        {link ? (
          <Link to={link.to} className="text-[13px] font-bold" style={{ color: 'var(--gs-accent)' }}>
            {link.label}
          </Link>
        ) : null}
      </div>
      {children}
    </section>
  );
}
